// The figure's four frames and their stroke groups as KanjiVG indices
// (0-based; landing spec §3.1 bullet 3). carry-frames.test.ts pins these
// to packages/database/scripts/data/kanjivg-groups.json.
export interface CarryFrame {
    character: string
    frame: number
    keyword: string
    part: { character: string; name: string; indices: number[] } | null
    carried: number[]
}

export const CARRY_FRAMES: readonly CarryFrame[] = [
    { character: '口', frame: 11, keyword: 'mouth', part: null, carried: [] },
    {
        character: '古',
        frame: 16,
        keyword: 'old',
        part: { character: '十', name: 'ten', indices: [0, 1] },
        carried: [2, 3, 4],
    },
    {
        character: '固',
        frame: 622,
        keyword: 'harden',
        part: { character: '囗', name: 'pent in', indices: [0, 1, 7] },
        carried: [2, 3, 4, 5, 6],
    },
    {
        character: '個',
        frame: 1047,
        keyword: 'individual',
        part: { character: '亻', name: 'person', indices: [0, 1] },
        carried: [2, 3, 4, 5, 6, 7, 8, 9],
    },
]
